export default {
  COMPONENT: 'obj.com.bmssolutions.COMPONENT',
  DATE: 'obj.com.bmssolutions.Date',
  LOOKUP: 'obj.com.bmssolutions.LOOKUP',
  QUESTION_YN: 'obj.com.bmssolutions.QuestionYNonly',
  TEXT: 'obj.com.bmssolutions.Text',
}
